import { isGoogleDocUrl } from '@spotify/confidence-core-react';
import {
  isCollaborativeDocument,
  isExternalDocument,
  isExternalLink,
} from '@spotify/plugin-confidence-artifacts-react';

export { isGoogleDocUrl };

export const getResourceName = (uri: string): string =>
  uri.replace(/^\/\//, '');

const RULE_PARENT_FLAG_RE = /^(?:\/\/)?(flags\/[^/]+)\/rules\/[^/]+$/;

export const isDocumentUri = isCollaborativeDocument;

export const getArtifactNavigationPath = (uri: string): string | undefined => {
  if (isExternalLink(uri) || isDocumentUri(uri) || isExternalDocument(uri)) {
    return undefined;
  }
  const resourceName = getResourceName(uri);
  const ruleMatch = uri.match(RULE_PARENT_FLAG_RE);
  if (ruleMatch) {
    return ruleMatch[1];
  }
  return resourceName;
};
